<template>
  <div class="interactive-module-prompt">
    <NebulaTextarea
      :aria-label="$t('Question prompt')"
      class="interactive-module-prompt__textarea"
      :disabled="isLocked(id)"
      :placeholder="placeholderText"
      :text="content"
      type="text"
      @blur="updatePrompt"
      @change="onChange"
    />
  </div>
</template>

<script>
import { NebulaTextarea } from '@discoveryedu/nebula-components';
import { mapState } from 'pinia';
import { decodeHTML } from '@/lib/utils';
import {
  useEditorStore,
} from '@/stores';

export default {
  name: 'InteractiveModulePrompt',
  components: {
    NebulaTextarea,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    canvasName: {
      type: String,
      required: true,
    },
    moduleData: {
      type: Object, // local module data cloned from the store
      required: true,
    },
  },
  emits: ['update-module'],
  data() {
    return {
      isDirty: false,
      content: '',
    };
  },
  mounted() {
    this.loadContent();
  },
  computed: {
    ...mapState(useEditorStore, [
      'isLocked',
    ]),
    placeholderText() {
      return this.$t('Type in question here');
    },
  },
  beforeUnmount() {
    this.updatePrompt();
  },
  methods: {
    onChange(e) {
      // clean up content
      const trimmedContent = e.target.value.trim();

      // set dirty flag
      this.isDirty = true;

      // set the content OR null so that the placeholder kicks in
      this.content = trimmedContent || null;
    },
    updatePrompt() {
      if (this.isDirty) {
        // set the module content. a falsy value will trigger validation errors
        this.moduleData.options.content = this.content;

        // emit post handler event
        this.$emit('update-module');
        this.isDirty = false;
      }
    },
    loadContent() {
      // on initial load, decode the string or use placeholder text
      const content = this.moduleData.options.content === this.placeholderText
        ? '' : this.moduleData.options.content;

      this.content = decodeHTML(content);
    },
  },
};
</script>

<style lang="stylus">
.interactive-module-prompt {
  &__textarea.nebula-textarea {
    max-width: 100%;
    min-height: $nebula-space-4x;
    resize: vertical;
    width: 100%;
  }
}
</style>
